import { Th, Tr } from '@chakra-ui/react';

import { TableColumns } from './ListTable';

interface Props<T> {
  columns: TableColumns<T>[];
}

export function TableHeader<T>({ columns }: Props<T>): JSX.Element {
  return (
    <Tr>
      {columns.map((column, columnIndex) => (
        <Th
          key={`table-head-cell-${columnIndex}`}
          style={{ width: column.width, color: column.color ?? 'gray' }}
          fontSize={column.fontSize ?? '16px'}
        >
          {column.title}
        </Th>
      ))}
    </Tr>
  );
}
